__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "application";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@emotion/react", "11.10.5", () => (Promise.all([__webpack_require__.e(513), __webpack_require__.e(914), __webpack_require__.e(328)]).then(() => (() => (__webpack_require__(7947))))));
			register("@emotion/styled", "11.10.5", () => (Promise.all([__webpack_require__.e(914), __webpack_require__.e(160), __webpack_require__.e(903)]).then(() => (() => (__webpack_require__(5903))))));
			register("@mui/icons-material", "5.11.16", () => (Promise.all([__webpack_require__.e(734), __webpack_require__.e(767), __webpack_require__.e(914), __webpack_require__.e(160), __webpack_require__.e(844)]).then(() => (() => (__webpack_require__(7767))))));
			register("@mui/material", "5.13.5", () => (Promise.all([__webpack_require__.e(513), __webpack_require__.e(734), __webpack_require__.e(554), __webpack_require__.e(914), __webpack_require__.e(672), __webpack_require__.e(160), __webpack_require__.e(844), __webpack_require__.e(145)]).then(() => (() => (__webpack_require__(4554))))));
			register("mobx-react", "7.6.0", () => (Promise.all([__webpack_require__.e(390), __webpack_require__.e(914), __webpack_require__.e(672), __webpack_require__.e(388)]).then(() => (() => (__webpack_require__(4390))))));
			register("mobx", "6.7.0", () => (__webpack_require__.e(812).then(() => (() => (__webpack_require__(4812))))));
			register("react-dom", "18.2.0", () => (Promise.all([__webpack_require__.e(950), __webpack_require__.e(914)]).then(() => (() => (__webpack_require__(7950))))));
			register("react-router-dom", "6.13.0", () => (Promise.all([__webpack_require__.e(245), __webpack_require__.e(914)]).then(() => (() => (__webpack_require__(3245))))));
			register("react", "18.2.0", () => (__webpack_require__.e(43).then(() => (() => (__webpack_require__(5043))))));
			register("web-vitals", "3.1.1", () => (__webpack_require__.e(488).then(() => (() => (__webpack_require__(2488))))));
			initExternal(1489);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};